import { hideModal } from "global/context/action/modal/modal";
import { GlobalContext } from "global/context/Provider";
import { useContext } from "react";
import { ContainerModalCentro } from "./localStyle";
import { FaMapMarkerAlt } from "react-icons/fa";

const ModalCentro = ({ item }) => {
  const { modalDispatch } = useContext(GlobalContext);

  const handleComoLlegar = () => {
    const url = `https://www.google.com/maps/dir/?api=1&destination=${item.coordenadaGps}&dir_action=navigate&travelmode=walking`;
    // const url = `https://maps.google.com/?q=${item.coordenadaGps}`;
    window.open(url, "_blank");
  };

  return (
    <ContainerModalCentro>
      {/* <span className="bold">¿Desea tomar el turno como particular?</span> */}
      <span>
        El turno seleccionado no esta cerca de tu ubicación, por favor
        acercate al centro del turno para comenzar con el proceso de
        recepcion
      </span>

      <span className="bold btn-como-llegar" onClick={handleComoLlegar}>
        <FaMapMarkerAlt color={"var(--color-latex30)"} size={20} /> ¿Como
        llegar?
      </span>

      <div className="container-btn">
        <button
          className="bgc-primary cancelar"
          onClick={() => hideModal()(modalDispatch)}
        >
          Cerrar
        </button>
      </div>
    </ContainerModalCentro>
  );
};
export default ModalCentro;
